import React, { useState } from "react";

const AppContext = React.createContext();

export const AppProvider = ({ children }) => {
    /* #region Main App */

    const [getUserDataToken, setGetUserDataToken] = useState(null); // Handles the token to fetch user data
    const [refreshUserData, setRefreshUserData] = useState(false); // When true, it will refresh the user data
    const [isLoadingApp, setIsLoadingApp] = useState(false); // Handles the loading state of the app
    const [redirectURL, setRedirectURL] = useState(null); // Handles the redirect URL after the user logs in

    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false); // Handles the state when there are unsaved changes
    const [showUnsavedChangesPopup, setShowUnsavedChangesPopup] = useState(false); // Handles the visibility of the unsaved changes popup
    const [userData, setUserData] = useState(null); // Handles the user data that is received from the "getUserData"
    /* #endregion */

    /* #region AI CHAT SIDE PANEL */
    const [aiChatLoading, setAiChatLoading] = useState(false); // Handles the loading state of the AI chat inside the chat window
    const [aiChatIsVisible, setAiChatIsVisible] = useState(true);
    const [aiChatIsDisabled, setAiChatIsDisabled] = useState(false);
    // ---- AI Chat Window and Side Panel States ----
    const [aiChatWindowOpen, setAiChatWindowOpen] = useState(false);
    const [aiChatSidePanelOpen, setAiChatSidePanelOpen] = useState(false);
    // ---- AI Chats conversation states ----
    const [showChatConversation, setShowChatConversation] = useState(true);
    const [showChatAllPanel, setShowChatAllPanel] = useState(false);
    const [showChatArchived, setShowChatArchived] = useState(false);
    // ---- AI Chat Messages ----
    const [aiChatMessages, setAiChatMessages] = useState([
        {
            id: 1,
            text: "Hi! I’m Felisha, your BOtag AI assistant. How can I help you?",
            sender: "bot",
            timestamp: new Date(),
            isLoadingMessage: true
        }
    ]);
    const [aiChatCurrentThreadID, setAiChatCurrentThreadID] = useState(null);
    const [aiActiveChats, setAiActiveChats] = useState([]);
    const [aiArchivedChats, setAiArchivedChats] = useState([]);
    /* #endregion */

    /* #region GLOBALS */
    const [pageRefreshFromNotification, setPageRefreshFromNotification] = useState(false); // Handles the state when the page is refreshed from a notification

    // const [showWelcomePopup, setShowWelcomePopup] = useState(false); // Handles the visibility of the welcome popup
    // const [showDownloadAppPopup, setShowDownloadAppPopup] = useState(false); // Handles the visibility of the download app popup
    // const [isPwaInstalled, setIsPwaInstalled] = useState(false); // Handles the state when the PWA is installed
    // const [firstLoginDone, setFirstLoginDone] = useState(false); // Handles the state when the first login is done
    /* #endregion */

    return (
        <AppContext.Provider
            value={{
                getUserDataToken,
                setGetUserDataToken,
                refreshUserData,
                setRefreshUserData,
                isLoadingApp,
                setIsLoadingApp,
                redirectURL,
                setRedirectURL,

                showUnsavedChangesPopup,
                setShowUnsavedChangesPopup,
                hasUnsavedChanges,
                setHasUnsavedChanges,

                userData,
                setUserData,

                aiChatLoading,
                setAiChatLoading,
                aiChatIsVisible,
                setAiChatIsVisible,
                aiChatIsDisabled,
                setAiChatIsDisabled,
                aiChatWindowOpen,
                setAiChatWindowOpen,
                aiChatSidePanelOpen,
                setAiChatSidePanelOpen,
                showChatConversation,
                setShowChatConversation,
                showChatAllPanel,
                setShowChatAllPanel,
                showChatArchived,
                setShowChatArchived,
                aiChatMessages,
                setAiChatMessages,
                aiChatCurrentThreadID,
                setAiChatCurrentThreadID,
                aiActiveChats,
                setAiActiveChats,
                aiArchivedChats,
                setAiArchivedChats,

                pageRefreshFromNotification,
                setPageRefreshFromNotification
            }}>
            {children}
        </AppContext.Provider>
    );
};

export default AppContext;
